export const policyLeftExpressions = {
  policyEvaluationTime: 'POLICY_EVALUATION_TIME',
  referringConnector: 'REFERRING_CONNECTOR',
};
